import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';
import { TLabelTicket } from '../types/label-ticket.type';

export const DeleteLabelTicketValidationSchema = z.object({
  labelTicketId: z.string({ message: 'Label ID is required' }).min(1),
});
export type TDeleteLabelTicketValidation = z.infer<typeof DeleteLabelTicketValidationSchema>;
export type TDeleteLabelTicketPayload = TDeleteLabelTicketValidation;
export type TDeleteLabelTicketResponse = ApiResponse<TLabelTicket>;

export const deleteLabelTicket = (payload: TDeleteLabelTicketPayload): Promise<TDeleteLabelTicketResponse> => {
  const url = `/label-ticket/${payload.labelTicketId}`;

  return axiosInstance.delete(url);
};

/**
 * Use Delete Label Ticket React-Query Hook
 */
type UseDeleteLabelTicketMutationOptions = {
  mutationConfig?: TypedMutationConfig<typeof deleteLabelTicket, AxiosErrorCustom>;
};

export const useDeleteLabelTicketMutation = ({ mutationConfig }: UseDeleteLabelTicketMutationOptions) => {
  const { ...restConfig } = mutationConfig ?? {};

  return useMutation({
    mutationFn: deleteLabelTicket,
    ...restConfig,
  });
};
